import readRegularWoff from './fonts/read/Read-Regular_V1100.woff';
import readRegularEot from './fonts/read/Read-Regular_V1100.eot';
import readLightWoff from './fonts/read/Read-Light_V1100.woff';
import readLightEot from './fonts/read/Read-Light_V1100.eot';
import readBoldWoff from './fonts/read/Read-Bold_V1100.woff';
import readBoldEot from './fonts/read/Read-Bold_V1100.eot';

import RenaultLifeEot from './fonts/renault-life/RenaultLifeWeb-Regular.eot';
import RenaultLifeWoff from './fonts/renault-life/RenaultLifeWeb-Regular.woff';
import RenaultLifeItalicEot from './fonts/renault-life/RenaultLifeWeb-Italic.eot';
import RenaultLifeItalicWoff from './fonts/renault-life/RenaultLifeWeb-Italic.woff';
import RenaultLifeBoldEot from './fonts/renault-life/RenaultLifeWeb-Bold.eot';
import RenaultLifeBoldWoff from './fonts/renault-life/RenaultLifeWeb-Bold.woff';
import RenaultLifeBoldItalicEot from './fonts/renault-life/RenaultLifeWeb-BoldItalic.eot';
import RenaultLifeBoldItalicWoff from './fonts/renault-life/RenaultLifeWeb-BoldItalic.woff';
import RenaultLifeLightEot from './fonts/renault-life/RenaultLifeWeb-Light.eot';
import RenaultLifeLightWoff from './fonts/renault-life/RenaultLifeWeb-Light.woff';
import RenaultLifeLightItalicEot from './fonts/renault-life/RenaultLifeWeb-LightItalic.eot';
import RenaultLifeLightItalicWoff from './fonts/renault-life/RenaultLifeWeb-LightItalic.woff';

import NouvelRTtf from './fonts/nouvelr/nouvelr-regular.ttf';
import NouvelRWoff from './fonts/nouvelr/nouvelr-regular.woff2';
import NouvelRBoldTtf from './fonts/nouvelr/nouvelr-bold.ttf';
import NouvelRBoldWoff from './fonts/nouvelr/nouvelr-bold.woff2';

const globalStyles = () => ({
  '@global': {
    '*': {
      boxSizing: 'border-box'
    },
    'html, body': {
      margin: 0,
      height: '100%'
    }
  },
  '@font-face': [
    {
      fontFamily: 'Read',
      fontWeight: '500',
      fontStyle: 'normal',
      src: `url(${readRegularWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${readRegularEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'Read',
      fontWeight: '400',
      fontStyle: 'normal',
      src: `url(${readLightWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${readLightEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'Read',
      fontWeight: '700',
      fontStyle: 'normal',
      src: `url(${readBoldWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${readBoldEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'RenaultLife',
      fontStyle: 'normal',
      fontWeight: 400,
      src: `url(${RenaultLifeWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${RenaultLifeEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'RenaultLife-Italic',
      fontStyle: 'normal',
      fontWeight: 400,
      src: `url(${RenaultLifeItalicWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${RenaultLifeItalicEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'RenaultLife-Bold',
      fontStyle: 'normal',
      fontWeight: 700,
      src: `url(${RenaultLifeBoldWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${RenaultLifeBoldEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'RenaultLife-BoldItalic',
      fontStyle: 'normal',
      fontWeight: 700,
      src: `url(${RenaultLifeBoldItalicWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${RenaultLifeBoldItalicEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'RenaultLife-Light',
      fontStyle: 'normal',
      fontWeight: 300,
      src: `url(${RenaultLifeLightWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${RenaultLifeLightEot}) format("eot")`}
      ]
    },
    {
      fontFamily: 'RenaultLife-LightItalic',
      fontStyle: 'normal',
      fontWeight: 300,
      src: `url(${RenaultLifeLightItalicWoff}) format("woff")`,
      fallbacks: [
        {src: `url(${RenaultLifeLightItalicEot}) format("eot")`}
      ]
    },

    // Renault Life
    {
      fontFamily: 'NouvelR',
      fontStyle: 'normal',
      fontWeight: 400,
      src: `url(${NouvelRWoff}) format("woff2")`,
      fallbacks: [
        {src: `url(${NouvelRTtf}) format("ttf")`}
      ]
    },
    {
      fontFamily: 'NouvelR-Bold',
      fontStyle: 'normal',
      fontWeight: 700,
      src: `url(${NouvelRBoldWoff}) format("woff2")`,
      fallbacks: [
        {src: `url(${NouvelRBoldTtf}) format("ttf")`}
      ]
    }
  ]
});

export default globalStyles;



// WEBPACK FOOTER //
// ./src/styles/global.jss.js